import(/* webpackMode: "eager" */ "/opt/hotlistcasino/frontend/src/app/global-error.tsx");
